module.exports = __webpack_public_path__ + "img/brightness-alt-low-fill.0a5e227a.svg";